
import React from 'react';

interface PerksPreviewProps {
  count: number;
}

const PerksPreview = ({ count }: PerksPreviewProps) => {
  return (
    <div className="mt-4 flex items-center text-sm text-redflags-gray">
      <span>{count} perk{count !== 1 ? 's' : ''} rated</span>
      <span className="ml-1 text-redflags-red">(click to view details)</span>
    </div>
  );
};

export default PerksPreview;
